import { render, staticRenderFns } from "./pro-classify-sub-add.vue?vue&type=template&id=ff593f82&scoped=true&"
import script from "./pro-classify-sub-add.vue?vue&type=script&lang=js&"
export * from "./pro-classify-sub-add.vue?vue&type=script&lang=js&"
import style0 from "./pro-classify-sub-add.vue?vue&type=style&index=0&id=ff593f82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff593f82",
  null
  
)

export default component.exports